<script>
import { useAlert, useTrack } from 'dashboard/composables';
import BotMetrics from './components/BotMetrics.vue';
import ReportFilters from './components/ReportFilters.vue';
import { GROUP_BY_FILTER } from './constants';
import ReportContainer from './ReportContainer.vue';
import { REPORTS_EVENTS } from '../../../../helper/AnalyticsHelper/events';
import ReportHeader from './components/ReportHeader.vue';
import ReportSourceNote from './components/ReportSourceNote.vue';

export default {
  name: 'BotReports',
  components: {
    BotMetrics,
    ReportHeader,
    ReportSourceNote,
    ReportFilters,
    ReportContainer,
  },
  data() {
    return {
      from: 0,
      to: 0,
      groupBy: GROUP_BY_FILTER[1],
      reportKeys: {
        BOT_RESOLUTION_COUNT: 'bot_resolutions_count',
        BOT_HANDOFF_COUNT: 'bot_handoffs_count',
      },
      businessHours: false,
      loadError: '',
      loadRequestId: 0,
    };
  },
  computed: {
    requestPayload() {
      return {
        from: this.from,
        to: this.to,
      };
    },
    filterErrorMessage() {
      return this.loadError;
    },
  },
  methods: {
    async fetchAllData() {
      this.loadRequestId += 1;
      const requestId = this.loadRequestId;
      const accountId = this.$store.getters.getCurrentAccountId;
      this.loadError = '';
      try {
        await Promise.all([
          this.$store.dispatch('fetchBotSummary', this.getRequestPayload()),
          this.fetchChartData(),
        ]);
      } catch {
        if (
          requestId !== this.loadRequestId ||
          accountId !== this.$store.getters.getCurrentAccountId
        )
          return;
        this.loadError = this.$t('REPORT.DATA_FETCHING_FAILED');
        useAlert(this.loadError);
      }
    },
    fetchChartData() {
      return Promise.all(
        Object.keys(this.reportKeys).map(key =>
          this.$store.dispatch('fetchAccountReport', {
            metric: this.reportKeys[key],
            ...this.getRequestPayload(),
          })
        )
      );
    },
    getRequestPayload() {
      const { from, to, groupBy, businessHours } = this;

      return {
        from,
        to,
        groupBy: groupBy?.period,
        businessHours,
      };
    },
    onFilterChange({ from, to, groupBy, businessHours }) {
      this.from = from;
      this.to = to;
      this.groupBy = groupBy;
      this.businessHours = businessHours;
      this.fetchAllData();

      useTrack(REPORTS_EVENTS.FILTER_REPORT, {
        filterValue: { from, to, groupBy, businessHours },
        reportType: 'bots',
      });
    },
  },
};
</script>

<template>
  <ReportHeader :header-title="$t('BOT_REPORTS.HEADER')" />
  <div class="flex flex-col gap-4">
    <ReportSourceNote
      :text="$t('REPORT.SOURCE_NOTE.BOT')"
      :link-label="$t('REPORT.SOURCE_NOTE.BOT_LINK')"
      area-id="ia"
      tab-id="painel"
    />
    <ReportFilters
      :show-entity-filter="false"
      show-group-by
      :show-business-hours="false"
      :error-message="filterErrorMessage"
      @filter-change="onFilterChange"
      @retry="fetchAllData"
    />

    <BotMetrics :filters="requestPayload" />
    <ReportContainer
      account-summary-key="getBotSummary"
      summary-fetching-key="getBotSummaryFetchingStatus"
      :group-by="groupBy"
      :report-keys="reportKeys"
    />
  </div>
</template>
